import React from "react"
import * as styles from "./style.module.scss"

const Available = () => {
  return (
    <div className={styles.available}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.54994 15.15L18.0249 6.675C18.2249 6.475 18.4583 6.375 18.7249 6.375C18.9916 6.375 19.2249 6.475 19.4249 6.675C19.6249 6.875 19.7249 7.11267 19.7249 7.388C19.7249 7.66333 19.6249 7.90067 19.4249 8.1L10.2499 17.3C10.0499 17.5 9.8166 17.6 9.54994 17.6C9.28327 17.6 9.04994 17.5 8.84994 17.3L4.54994 13C4.34994 12.8 4.25394 12.5627 4.26194 12.288C4.26994 12.0133 4.37427 11.7757 4.57494 11.575C4.7756 11.3743 5.01327 11.2743 5.28794 11.275C5.5626 11.2757 5.79994 11.3757 5.99994 11.575L9.54994 15.15Z"
          fill="#FC7C01"
        />
      </svg>
      Входит в стоимость тарифа
    </div>
  )
}

export default Available
